import { withDependencies } from '@wix/thunderbolt-ioc'
import { named } from '@wix/thunderbolt-ioc'
import type { ImportMapProvider } from '@wix/thunderbolt-symbols'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import type { BuilderComponentSiteConfig } from './types'
import { buildEditorReactComponentMapping } from '@wix/thunderbolt-commons'

const isEditor = process.env.PACKAGE_NAME === 'thunderbolt-ds'

export const builderComponentImportMapProvider = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(siteConfig: BuilderComponentSiteConfig): ImportMapProvider => {
		return {
			provideImportMap: () => {
				return buildEditorReactComponentMapping(siteConfig.builderComponentsData.components, isEditor)
			},
		}
	}
)
